import { ADD_MULTIPLE, ADD, UPDATE, REMOVE } from './constants';

export const addMultipleAction = (partners) => ({
  type: ADD_MULTIPLE,
  partners,
});

export const addAction = (partner) => ({
  type: ADD,
  partner,
});

export const updateAction = (partner) => ({
  type: UPDATE,
  partner,
});

export const removeAction = (partner) => ({
  type: REMOVE,
  partner,
});
